angular.module('app', [])

.controller('mainCtrl', ['$scope', '$http', '$window', '$timeout', function ($scope, $http, $window, $timeout) {

  var dev = angular.element('body').hasClass('env-development');
  var baseAppUrl = '/ask';
  var communityApiUri = dev ? "https://beta.familysearch.org/service/help/sf-facade" : "/service/help/sf-facade";
  var baseWikiUrl = dev ? "https://beta.familysearch.org" : "https://www.familysearch.org";

  FS.User.shouldSeeTempleInfo().then(pref => {
    $scope.checkMember = pref;
  });
  $scope.videos = {
    playerId: 1995251660001,
    playerKey: 'AQ~~,AAAAsMO7iuE~,0a6boL_aMzSw_yxPb4s-860v3o94zt2u',
    introductionToTheTree: {
      memberLength: '(2:19)',
      publicLength: '(1:46)',
      en: {name: 'Introduction to the FamilySearch Family Tree', memberId: 1828151687001, publicId: 2176145562001},
      eo: {name: 'Enkonduko al la FamilySearch Familia Arbo', memberId: 1828151687001, publicId: 2176145562001},
      es: {name: 'Introducción al programa Árbol Familiar de FamilySearch', memberId: 1939863224001, publicId: 2176145576001},
      ru: {name: 'Введение в Семейное древо FamilySearch', memberId: 1939863226001, publicId: 2176145574001},
      fr: {name: 'Présentation de l’arbre généalogique FamilySearch', memberId: 1939863228001, publicId: 2176145564001},
      zh: {name: 'FamilySearch「家譜樹」簡介', memberId: 1939863230001, publicId: 2176145580001},
      ko: {name: 'FamilySearch 패밀리 트리의 소개', memberId: 1939863232001, publicId: 2176145570001},
      de: {name: 'Einführung in den „Familienstammbaum“ von FamilySearch', memberId: 1939863234001, publicId: 2176145560001},
      it: {name: 'Introduzione a Family Tree di FamilySearch', memberId: 1939863236001, publicId: 2176145566001},
      ja: {name: 'ファミリーサーチのファミリーツリーの紹介', memberId: 1939863240001, publicId: 2176145568001},
      pt: {name: 'Introdução à Árvore Familiar do FamilySearch', memberId: 1939863242001, publicId: 2176145572001}
    },
    infoAboutAncestor: {
      memberLength: '(2:50)',
      publicLength: '(2:29)',
      en: {name: 'Step 3: Find and Serve Your Ancestors', memberId: 2176145514001, publicId: 2176145586001},
      eo: {name: 'Paŝo 3 : Trovu kaj Servu Via Prapatroj', memberId: 2176145514001, publicId: 2176145586001},
      es: {name: 'Paso 3: Encuentre y brinde servicio a sus antepasados', memberId: 2176145528001, publicId: 2176149640001},
      ru: {name: 'Шаг 3: найдите ваших предков и служите им', memberId: 2176145526001, publicId: 2176149638001},
      fr: {name: '3e étape : Rechercher et servir ses ancêtres', memberId: 2176145516001, publicId: 2176145588001},
      zh: {name: '步驟3：尋找你的祖先並為他們服務', memberId: 2176145510001, publicId: 2176149644001},
      ko: {name: '3단계: 나의 조상을 찾아서 봉사하기', memberId: 2176145522001, publicId: 2176145594001},
      de: {name: 'Schritt 3: Suchen Sie Ihre Vorfahren und dienen Sie ihnen', memberId: 2176145512001, publicId: 2176145584001},
      it: {name: '3º passo: trova e servi i tuoi antenati', memberId: 2176145518001, publicId: 2176145590001},
      ja: {name: 'ステップ 3：自分の先祖を見つけて奉仕する', memberId: 2176145520001, publicId: 2176145592001},
      pt: {name: 'Passo 3: Encontre e Sirva Seus Antepassados', memberId: 2176145524001, publicId: 2176149636001}
    },
   /* searchTips: { //not currently used
      memberLength: '(3:26)',
      publicLength: '(3:26)',
      en: {name: 'FamilySearch: Search Tips', memberId: 1695639132001, publicId: 1695639132001},
      eo: {name: 'FamilySearch : Serĉu Konsiloj', memberId: 1695639132001, publicId: 1695639132001},
      es: {name: 'Árbol Familiar vacío', memberId: 2433655660001, publicId: 2433655660001},
      ru: {name: 'Незаполненное Семейное древо', memberId: 2433655656001, publicId: 2433655656001},
      fr: {name: 'Arbre vide', memberId: 2433655646001, publicId: 2433655646001},
      zh: {name: '空白家譜樹', memberId: 2433655644001, publicId: 2433655644001},
      ko: {name: '비어 있는 패밀리 트리', memberId: 2433655654001, publicId: 2433655654001},
      de: {name: 'Leerer Stammbaum', memberId: 2433655648001, publicId: 2433655648001},
      it: {name: 'Un Albero familiare vuoto', memberId: 2433655650001, publicId: 2433655650001},
      ja: {name: '空のファミリーツリー', memberId: 2433655652001, publicId: 2433655652001},
      pt: {name: 'Árvore Familiar Vazia', memberId: 2433655658001, publicId: 2433655658001}
    },*/
    deceasedAncestors: {
      memberLength: '(3:09)',
      publicLength: '(3:09)',
      en: {name: 'FamilySearch: When Your Family Tree Is Empty!', memberId: 2235480393001, publicId: 2235480393001},
      eo: {name: 'FamilySearch : Kiam Via Familia Arbo Ĉu Malplena !', memberId: 2235480393001, publicId: 2235480393001},
      es: {name: 'Árbol Familiar vacío', memberId: 2433655660001, publicId: 2433655660001},
      ru: {name: 'Незаполненное Семейное древо', memberId: 2433655656001, publicId: 2433655656001},
      fr: {name: 'Arbre vide', memberId: 2433655646001, publicId: 2433655646001},
      zh: {name: '空白家譜樹', memberId: 2433655644001, publicId: 2433655644001},
      ko: {name: '비어 있는 패밀리 트리', memberId: 2433655654001, publicId: 2433655654001},
      de: {name: 'Leerer Stammbaum', memberId: 2433655648001, publicId: 2433655648001},
      it: {name: 'Un Albero familiare vuoto', memberId: 2433655650001, publicId: 2433655650001},
      ja: {name: '空のファミリーツリー', memberId: 2433655652001, publicId: 2433655652001},
      pt: {name: 'Árvore Familiar Vazia', memberId: 2433655658001, publicId: 2433655658001}
    }
  }

  FS.User.shouldSeeTempleInfo().then(pref => {

    var memberIdSelector = pref ? 'memberId' : 'publicId';
    var memberLengthSelector = pref ? 'memberLength' : 'publicLength';

    var videoList = [
    {
      elId: "introToTreeVideo",
      name: $scope.videos.introductionToTheTree[FS.simpleLocale()].name,
      id: $scope.videos.introductionToTheTree[FS.simpleLocale()][memberIdSelector],
      length: $scope.videos.introductionToTheTree[memberLengthSelector]
    },
    {
      elId: "infoAboutVideo",
      name: $scope.videos.infoAboutAncestor[FS.simpleLocale()].name,
      id: $scope.videos.infoAboutAncestor[FS.simpleLocale()][memberIdSelector],
      length: $scope.videos.infoAboutAncestor[memberLengthSelector]
    },
    /*{
      elId: "searchTipsVideo",
      name: $scope.videos.searchTips[FS.simpleLocale()].name,
      id: $scope.videos.searchTips[FS.simpleLocale()][memberIdSelector],
      length: $scope.videos.searchTips[memberLengthSelector]
    },*/
    {
      elId: "deceasedAncestorsVideo",
      name: $scope.videos.deceasedAncestors[FS.simpleLocale()].name,
      id: $scope.videos.deceasedAncestors[FS.simpleLocale()][memberIdSelector],
      length: $scope.videos.deceasedAncestors[memberLengthSelector]
    }];

    videoList.forEach(video => {
      var videoEl = document.querySelector(`#${video.elId}`);
      videoEl.setAttribute("data-control", "/modules/VideoPlayer/VideoPlayer");
      videoEl.setAttribute("data-config", `{"playerId":"${$scope.videos.playerId}", "playerKey":"${$scope.videos.playerKey}", "videoId":"${video.id}", "showInModal":true}`);
      var p = videoEl.querySelector("p");
      p.innerText = `${video.name} ${video.length}`;
    });

    FS.Controls.init();
  });

  $scope.showNoLocationPopup = false;
  $scope.loading = true;
  $scope.toggleConsultants = true;
  $scope.consultantLimit = 2;
  $scope.hasLocalHelp = false;
  $scope.showFirstRunCTA = false;

  var fhCenters;
  var sessionId = FS.Cookie.getCookie('fssessionid');

  var baseLocationUrl = "/locations/centerlocator";

  $scope.findFHC = function () {
    $scope.findNearbyLoading = true;
    window.open(FS.htmlEncode(baseLocationUrl + "?c=" + $scope.locationSearch));
    $timeout(function(){
      $scope.findNearbyLoading = false;
    }, 1500);
  };

  $scope.$watch('locationSearch', function() {
    console.log($scope.locationSearch);
  });

  /****************** find family history centers based upon geolocation data ********/
  $scope.findFHCByGeolocation = function (isDestination, data) {
    var newTab = window.open('', '_blank');
    if (navigator.geolocation) {
      $scope.findNearbyLoading = true;
      navigator.geolocation.getCurrentPosition(
        function success(loc) {
          if(isDestination){
            newTab.location = 'https://www.google.com/maps/dir/' + loc.coords.latitude + '+' + loc.coords.longitude + '/\'' + data[1] + ',' + data[0] + '\'';
          }
          else{
            newTab.location = 'https://www.google.com/maps/dir/' + data + '/\'' + loc.coords.latitude + ',' + loc.coords.longitude + '\'';
          }
          $scope.findNearbyLoading = false;
          $scope.$apply();
        },
        function error() {
          newTab.close();
          $scope.findNearbyLoading = false;
          $scope.showNoLocationPopup = true;
          $scope.$apply();
        },
        {timeout: 5000, maximumAge: 1800000}
      );
    } else {
      newTab.close();
      $scope.showNoLocationPopup = true;
      $scope.$apply();
    }
  }


  function getFhcListUrls(item) {
    var id = item.id;
    $http.get(baseAppUrl + '/getFhcUrlById', {params: {fhcId: id}})
    .success(function (res) {
      item.url = res;
    })
    .error(function (res) {
        console.log('ERROR');
      }
    );
  }

  /*********** get a list of family history centers near a geolocation *******/
  $scope.findFHCListByGeolocation = function() {
    if (navigator.geolocation) {
      $scope.loading = true;
      $scope.findNearbyLoading = true;
      navigator.geolocation.getCurrentPosition(
        function success(loc) {
          var params = {coordinates: '%5B' + loc.coords.longitude + ',' + loc.coords.latitude + '%5D', lang: FS.simpleLocale()};
          $http.get(baseAppUrl + '/getNearbyFhcList', {params: params})
          .success(function (res) {
            var theList = $scope.fhCenters = res;
            theList.map(getFhcListUrls);
            $scope.loading = false;
            $scope.findNearbyLoading = false;
            if($scope.fhCenters.length > 0 || FS.simpleLocale() == 'en' || FS.simpleLocale() == 'es'){
              $scope.hasLocalHelp = true;
            }
            $timeout(function(){
              console.log($scope.fhCenters)
            }, 1000);
          })
          .error(function (res) {
              console.log('ERROR');
            }
          );
        },
        function error() {
          $scope.loading = false;
          $scope.findNearbyLoading = false;
          $scope.showNoLocationPopup = true;
          $scope.$apply();
        },
        {timeout: 5000, maximumAge: 1800000}
      );
    } else {
      $scope.showNoLocationPopup = true;
      $scope.$apply();
    }
    $timeout(function(){
      if(!$scope.fhCenters){
        $scope.loading = false;
        $scope.findNearbyLoading = false;
        $scope.showNoLocationPopup = true;
        $scope.$apply();
      }
    }, 10000);
  }


  $scope.openChat = function () {
    var strWindowFeatures = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=600,height=700";
    $http.get(baseAppUrl + '/help/inContactUrl').success(function (res) {
      window.open(res.inContactUrl, 'Chat Client', strWindowFeatures);
    });
  };

  navigator.geolocation.getCurrentPosition(
    function success() {
    },
    function error() {
    },
    {timeout: 5000, maximumAge: 1800000}
  );

  // if the user has a sparse family tree, show a custom header and link to first run
  var url = '/service/tree/tree-data/pedigree/sparse';
  $http.get(url)
  .success(function (res) {
      $scope.showFirstRunCTA = !!res.data;
    }
  );

  FS.User.shouldSeeTempleInfo().then(pref => {
    if (pref) {
      // Get the family history center and family history consultant info
      $http.get(communityApiUri + '/familyhistorylocalinfo/getfamilyhistorylocalinfo', {params: {sessionid: sessionId}})
      .success(function (res) {
          fhCenters = res;
          $scope.fhCenters = fhCenters.familyHistoryCenters.familyHistoryCenter || fhCenters.familyHistoryCenters.familyHistoryCenters;
          $scope.fhConsultants = fhCenters.familyHistoryConsultants.familyHistoryConsultant || fhCenters.familyHistoryConsultants.familyHistoryConsultant;
          for (i = 0; i < $scope.fhCenters.length; i++) {
            (function (i) {
              var ctr = $scope.fhCenters[i];
              $http.get(baseWikiUrl + '/wiki/en/extensions/FsApi/FsApiExtension.php', {
                params: {action: "unitNbrToFhcWikiPage", unitNbr: ctr.unitNumber}
              }).success(function (res) {
                ctr.locationUrl = res.substring(res.indexOf("<rev>") + 5, res.indexOf("</rev>"));
              });
            }(i));
          }
          if ($scope.fhCenters.length > 0 || $scope.fhConsultants.length > 0 || FS.simpleLocale() == 'en' || FS.simpleLocale() == 'es') {
            $scope.hasLocalHelp = true;
          }
          $scope.loading = false;
        }
      );
    }
    else {
      $scope.findFHCListByGeolocation();
    }
  })
}

])

.directive('fsControlsInit',['$timeout', function (timer) {
  return {
    link: function ($scope, $element, $attrs) {
      timer(function(){
        $element.attr('data-control', '/modules/VideoPlayer/VideoPlayer');
        FS.Controls.init();
      }, 0);
    }
  }
}]);